import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";

const nullifyString = value => value === '' ? null : value;

const builder = {
  and: function () {
    for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
      queries[_key] = arguments[_key];
    }

    return nullifyString(_filterInstanceProperty(queries).call(queries, i => i).join(' and '));
  },
  or: function () {
    for (var _len2 = arguments.length, queries = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      queries[_key2] = arguments[_key2];
    }

    return nullifyString(_filterInstanceProperty(queries).call(queries, i => i).join(', '));
  },
  minWidth: width => width && width !== '0px' ? `(min-width: ${width})` : null,
  maxWidth: width => width ? `(max-width: ${width})` : null,
  minResolution: res => res && res !== '96dpi' ? `(min-resolution: ${res})` : null,
  maxResolution: res => res ? `(max-resolution: ${res})` : null,
  minPixelDensity: density => density && density !== '1' ? `(-webkit-min-device-pixel-ratio: ${density})` : null,
  maxPixelDensity: density => density ? `(-webkit-max-device-pixel-ratio: ${density})` : null
};

const createMediaQuery = _ref => {
  let {
    minResolution,
    maxResolution,
    minPixelDensity,
    maxPixelDensity,
    minWidth,
    maxWidth
  } = _ref;
  return builder.or(builder.and(builder.minResolution(minResolution), builder.minWidth(minWidth), builder.maxResolution(maxResolution), builder.maxWidth(maxWidth)), builder.and(builder.minPixelDensity(minPixelDensity), builder.minWidth(minWidth), builder.maxPixelDensity(maxPixelDensity), builder.maxWidth(maxWidth)));
};

export default createMediaQuery;